import React from "react";

const WhyChooseAndroid = () => {
return ( 
<section className=" w-full max-w-none p-20 px-6 bg-[#f1f4fa]"> 
    <div className="mx-auto">

    <h2 className="text-3xl font-bold mb-6 text-center">
      Why Choose Our Android App<span className="text-[#ff4a17]"> Development Services</span>
    </h2>

    <div className="space-y-6 text-gray-600 leading-relaxed text-sm">
      
      <p>
        As a reliable Android app development partner, we bring together
        strong technical expertise and modern development practices to
        create high-quality mobile applications. Our developers specialize
        in Kotlin, Java, Android SDK, and Jetpack to build apps that are
        fast, stable, and secure. We ensure seamless navigation, responsive
        layouts, and designs that align perfectly with Android standards,
        delivering a truly native user experience.
      </p>

      <p>
        We focus on building scalable Android solutions that grow with your
        business. Our team develops clean architectures, reusable modules,
        and flexible APIs that allow easy expansion without major rework.
        From analytics integration and crash monitoring to push
        notifications and real-time messaging, we equip your app with all
        the essential tools needed for long-term success.
      </p>

      <p>
        Our approach is driven by your business goals. We help you refine
        your ideas, prioritize the right features, and accelerate your time
        to market with a clear and structured roadmap. Through continuous
        testing, UX validation, performance optimization, and security
        checks, we ensure your Android application meets user expectations
        while maintaining industry standards and compliance.
      </p>

    </div>
  </div>
</section>
);
};

export default WhyChooseAndroid;
